import * as React from 'react'
import { Entity } from 'ts-lenses'
import { ComponentMountCycle, fromJSX, Updater, Widget } from 'widgets-for-react'
import { Loader } from '../../../Shared/Frontend/utils/loader'
import { RootLayout } from '../root/root.layout'
import { renderReadSpeaker, State } from './cmsPage.widget'
import { renderPageHeader } from './header/pageHeader/pageHeader.layout'
import { modernBlocksWidget } from './modernBlocks/modernBlocks.widget'
import { SharingLayout } from './header/pageHeader/sharing.layout'
import { scrollToHash } from './utils/html'
import { addWindowEvents, removeWindowEvents } from './utils/windowEvents'
import { ReadSpeaker } from '../readspeaker/readspeaker.widget'
import { TableOfContentsWidget } from './tableOfContents/tableOfContents.widget'

export function renderPage(localState: State, setState: (_: Updater<State>) => void): Widget<Updater<State>> {
  return fromJSX((setState) => {
    const pagekind = localState.rootModernBlocksState.loader.kind == 'loaded' ? localState.rootModernBlocksState.loader.value.pageData?.page?.kind : '';
    const blocks = localState.rootModernBlocksState.modernBlocks.blocks;
    const hasTableOfContents = localState.rootModernBlocksState.loader.kind == 'loaded' ? localState.rootModernBlocksState.loader.value.pageData.tableOfContents : false;

    return (
      <>
       {/* <ComponentDidMount
          onMount={() => {
            const existingScript = document.getElementById('recaptcha');
  
            if (!existingScript) {
              const script = document.createElement('script')
              script.id = "recaptcha"
              script.type = 'text/javascript'
              script.defer = true
              script.src = 'https://www.google.com/recaptcha/api.js'
              script.onload = () =>
                (window as any)['grecaptcha'].ready(() => {
                  setState((state) => ({ ...state, recaptchaReady: true }))
                })
              document.body.appendChild(script)
            }
          }}
        /> */}
        {
          (localState.rootModernBlocksState.loader.kind === 'loading') ? (
            <Loader type='full' />
          ) : (localState.rootModernBlocksState.loader.kind === 'failed') ? (
            <RootLayout.Error kind='notFound' showReadspeaker={renderReadSpeaker(localState)}/>
          ) : (
            <ComponentMountCycle onMount={() => { addWindowEvents({type: 'global'}), scrollToHash()}} onUnmount={() => removeWindowEvents({type: 'global'})}>
              <main id="a11y-main" className="main">
                <article className={`page page--${retrievePageClass(localState.isCustomPage)}`}>
                  <div className='page__content'>
                    {renderPageHeader(localState, localState.rootModernBlocksState.loader).run(setState)}
                  
                    {(localState.isCustomPage != 'storyPageState' && localState.isCustomPage != 'searchPageState' && localState.isCustomPage !== "newsletterPageState" && window.location.pathname != '/' && pagekind != 'donatie_pagina') ?
                      <SharingLayout.Wrap>
                        {renderReadSpeaker(localState) == true && <ReadSpeaker keyId="a1" encodedUrl={encodeURI(window.location.href)} readElementId={'a11y-main'} />}
                        <SharingLayout.Button />
                        <SharingLayout.Popup />
                      </SharingLayout.Wrap>
                    : <></>}

                    {hasTableOfContents && blocks.toArray().length > 1 &&
                      <TableOfContentsWidget blocks={blocks} /> || <></>
                    }

                    {localState.isCustomPage == 'none'
                      ? renderModernBlocks(localState, setState)
                      : localState[localState.isCustomPage].widget(localState).run(setState)}
                  </div>
                </article>
              </main>
            </ComponentMountCycle>
          )
        }
      </>
    )
  })
}

export function retrievePageClass(pageKind: string) {
  if(pageKind == 'searchPageState' || pageKind == 'storyOverviewPageState' || pageKind == 'newsOverviewPageState') {
    return 'overview';
  }
  if(pageKind == 'storyPageState') {
    return 'story';
  }
  return 'default';
}

export function renderModernBlocks(localState: State, setState: (_: Updater<State>) => void) {
  return modernBlocksWidget(localState.rootModernBlocksState.modernBlocks.blocks, setState, localState).run(
    (updatedModerBlocks) =>
      setState((s) => {
        return {
          ...s,
          rootModernBlocksState: Entity(s.rootModernBlocksState)
            .set('modernBlocks', (prevModernBlocksState) => ({
              ...prevModernBlocksState,
              blocks: updatedModerBlocks(prevModernBlocksState.blocks)
            }))
            .commit()
        }
      })
  )
}
